<template>
  <div class="alert alert-success text-center col-12 my-4 p-0 border-0" :style="['max-height: ' + (parseInt(altura) + parseInt(20)) + 'px']">
    <div class="carousel slide carousel-fade w-100 d-flex align-items-center" data-bs-ride="carousel" :style="['max-height: ' + altura + 'px']" v-if="midia.length > 0">
      <div class="carousel-inner">
        <a v-for="(item, i) in midia" :key="i" href="/" target="_blank">
          <div :class="['carousel-item', (i == 0 ? 'active' : '')]" data-bs-interval="4000">
            <img :src="item" class="d-block w-100" alt="...">
          </div>
        </a>
      </div>
      <div v-if="false">
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying"
          data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying"
          data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>

    <div class="h6 fs-bolder p-3" v-if="midia.length == 0" :style="['height: ' + altura + 'px']">
      Anuncie aqui <br><br>
      <a target="_blank"
        :href="'https://api.whatsapp.com/send?phone=5524998781800&text=Gostaria de anunciar no banner `' + nome_exibicao + '` do saiadosofabr.com.br.'"
        class="btn btn-info btn-sm text-white">
        Clique aqui para entrar em contato
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Propaganda',
  props: {
    altura: {
      default: '100'
    },
    nome_exibicao: {
      default: 'Banner'
    },
    whatsapp: {
      // default: {
      //   telefone: '',
      //   mensagem: ''
      // }
    },
    site: {
      default: ''
    },
    midia: {
      default: []
    }
  },
  data() {
    return {
      anuncio: [],
    }
  },
  components: {}
}
</script>

<style scoped>
.fundo {
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>